<template>
  <component
    :is="as"
    :class="['cta-card card', { active }]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <icon :name="icon" />
    <h5>{{ title }}</h5>
    <p>{{ description }}</p>
  </component>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    description: String,
    active: Boolean,
    as: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style lang="scss" scoped>
.cta-card {
  cursor: pointer;
  text-decoration: none;
  @include transition(all);
  text-align: center;

  &.active {
    border: 1px solid $color-green-1;
  }

  .icon {
    color: $color-green-1;
    font-size: 40px;
    margin-bottom: $gp;
  }

  h5 {
    margin-bottom: $gp * .5;
  }

  &:hover {
    transform: scale(1.05);
  }

  @media($small-down) {
    max-width: 100%;
    width: 100%;
  }
}
</style>
